/**
 * 年月から有効な末日で option を生成する.
 *
 * @returns {void}
 */
const lastDayOfMonth = (): void => {
    document
        .querySelectorAll<HTMLElement>(".js-last-day-of-month")
        .forEach((element) => {
            const year =
                element.querySelector<HTMLSelectElement>(".js-target-year");
            const month =
                element.querySelector<HTMLSelectElement>(".js-target-month");
            const day =
                element.querySelector<HTMLSelectElement>(".js-target-day");

            if (!year || !month || !day) return;

            const updateDays = () => {
                const yearValue = parseInt(year.value, 10);
                const monthValue = parseInt(month.value, 10);
                if (isNaN(yearValue) || isNaN(monthValue)) return;

                const lastDay = new Date(yearValue, monthValue, 0).getDate();
                const current = parseInt(day.value, 10);

                day.innerHTML = '<option value="" disabled>-</option>';
                for (let d = 1; d <= lastDay; d++) {
                    const selected = d === current ? "selected" : "";
                    day.insertAdjacentHTML(
                        "beforeend",
                        `<option value="${d}" ${selected}>${d}</option>`
                    );
                }
            };

            year.addEventListener("change", updateDays);
            month.addEventListener("change", updateDays);

            updateDays();
        });
};

export default lastDayOfMonth;
